.voided-tracking-number {
  text-decoration: line-through;
}
